window.HS = window.HS || {};

(function () {
  "use strict";

  var HS = (function () {
    function waitFor(variable, callback, limit) {
      let count = 0;
      let check = false;
      let interval = setInterval(function () {
        count++;
        if (count <= limit) {
          if (
            variable.includes(".") ||
            variable.includes("#") ||
            variable.includes("[")
          ) {
            check = document.querySelector(variable);
          } else {
            check = window[variable];
          }
          if (check) {
            console.info(
              `[mood:] waited ${count / 10} second(s) for ${variable}`
            );
            clearInterval(interval);
            callback();
          }
        } else {
          clearInterval(interval);
          removeLoading();
          console.error(`[mood:] took to long to wait for: ${variable}`);
        }
      }, 10);
    }

    function removeLoading() {
      const moodSubscriptionLoading = document.querySelector(
        ".subscriptions-loading"
      );
      if (moodSubscriptionLoading) {
        moodSubscriptionLoading.remove();
      }
    }

    function updateWidget() {
      /* ReCharge Elements */
      const subscriptionEl = document.querySelector(".subscription-radio");
      const reChargeDiscount = document.querySelector(
        ".rc-radio__subscription"
      );
      const subscribeLabel = reChargeDiscount.innerHTML;
      const reChargesavings = subscribeLabel
        .replace("Subscribe &amp; save", "")
        .replace("Subscribe", "");

      const oneTimeRadio = document.querySelector(".onetime-radio");
      const oneTimeLabel = oneTimeRadio.querySelector(".rc-radio__label");
      const oneTimePrice = oneTimeLabel.innerHTML.replace(
        "One-time purchase ",
        ""
      );
      oneTimeLabel.innerHTML = `<span class="rc-radio__label">One-time purchase</span><span class="rc-radio__price">${oneTimePrice}</span>`;

      /* Subscribe Element */
      if (reChargesavings === "") {
        reChargeDiscount.innerHTML = "Subscribe";
      } else {
        reChargeDiscount.innerHTML = `Subscribe <span class="rc-option__discount rc_widget__option__discount">Save ${reChargesavings}</span>`;
      }

      const subscriptionInfo =
        document.querySelector("#subscription-info").innerHTML;
      subscriptionEl.insertAdjacentHTML("beforeEnd", subscriptionInfo);

      removeLoading();
    }

    return {
      init: function () {
        waitFor(".rc-widget", updateWidget, 500);
      },
    };
  })();

  HS.init();
})();
